import { useContext, useEffect, useState } from "react";
import Web3 from "web3";
import { AppContext } from "../AppContext";
import { ETH_CRYPTO_VALUES } from "../../constants/eth/offers";
import { CONTRACT_ADDRESS } from "../../constants/env";
import ABI from "../../constants/abi.json";
import TOKEN_ABI from "../../constants/token_abi.json";

const useMyOffers = () => {
  const { chainState, chainID } = useContext(AppContext);
  const [myEthOffers, setMyEthOffers] = useState([]);
  const [ethIsLoading, setEthIsLoading] = useState(false);
  const [ethRefresh, setEthRefresh] = useState(false);

  const discontinueEthOffer = async (offerIndex) => {
    if (!chainID || !chainState.provider) {
      return;
    }
    const web3 = new Web3(chainState.provider);
    const contract = new web3.eth.Contract(ABI, CONTRACT_ADDRESS[chainID]);
    await contract.methods.cancelOffer(offerIndex).send({from: chainState.address});
    const newMyOffers = await getMyEthOffers();

    return newMyOffers;
  }

  const getMyEthOffers = async () => {
    let allMyOffers = [];
    const web3 = new Web3(chainState.provider);
    const contract = new web3.eth.Contract(ABI, CONTRACT_ADDRESS[chainID]);
    const offerIndexes = await contract.methods.getOfferIndexesOfUser(chainState.address).call();
    for (let offerIndex of offerIndexes) {
      const offer = await contract.methods.getOfferByIndex(offerIndex).call();
      console.log(offer)
      let decimal = 18;
      if (!offer.eth) {
        const contract = new chainState.web3.eth.Contract(TOKEN_ABI, offer.token_address);
        decimal = await contract.methods.decimals().call();
      }
      const tokenName = ETH_CRYPTO_VALUES[chainID].filter(item => item.value.toLowerCase() === offer.token_address.toLowerCase());
      const date = new Date(offer.created_at * 1000);
      const tokenAmount = Number.parseInt(offer.token_amount) / 10 ** decimal;
      const maxLimit = offer.max_limit / 10 ** decimal;
      const minLimit = offer.min_limit / 10 ** decimal;
      allMyOffers.push({
        ...offer,
        main: offer.eth,
        token: offer.token_address,
        paymentOptions: offer.payment_options,
        tokenAmount,
        tokenName: offer.eth ? ETH_CRYPTO_VALUES[chainID][0].title : tokenName[0].title,
        offer: offer.offer_index, 
        bought: offer.bought / 10 ** decimal,
        maxLimit: tokenAmount < maxLimit ? tokenAmount : maxLimit,
        minLimit: tokenAmount < minLimit ? tokenAmount : minLimit,
        timeLimit: offer.time_limit * 1,
        unixTime: offer.created_at,
        createdAt: date.toDateString() + " " + date.toLocaleTimeString(),
      });
    }

    return allMyOffers;
  }

  useEffect(() => {
    if (!chainState.provider) {
      return;
    }
    (
      async () => {
        setEthIsLoading(true);
        const newMyOffers = await getMyEthOffers();
        setMyEthOffers(newMyOffers);
        setEthIsLoading(false);
        setEthRefresh(false);
      }
    )();
  }, [chainState, ethRefresh])

  return {ethIsLoading, myEthOffers, ethRefresh, setEthRefresh, getMyEthOffers, discontinueEthOffer}
}

export default useMyOffers;